import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {screenStep} from './BusinessReportEnums';

export const getCustomerReports = createAsyncThunk('businessReport/getCustomerReports', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('getReportsForCustomer', [data]);
    console.log('result from backend: ', result);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

export const getBansForOrg = createAsyncThunk('businessReport/getBansForOrg', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('getBansForOrganization', [data]);
    console.log('result from backend: ', result);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

export const sendReportToCustomer = createAsyncThunk('businessReport/sendReportToCustomer', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('sendReportToCustomer', [
      data.blockId,
      data.orgId,
      data.mail,
      data.filters,
      data.reportName,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

const initialState = {
  orgList: [],
  selectedOrg: null,
  reportList: [],
  selectedReport: null,
  error: null,
  filterListValues: [],
  screenStep: screenStep.MAIN,
  orgBanList: [],
};

const BusinessReportBlockSlice = createSlice({
  name: 'businessReport',
  initialState: initialState,
  reducers: {
    resetState: (state) => {
      (state.reportList = []),
        (state.selectedReport = null),
        (state.error = null),
        (state.filterListValues = []),
        (state.screenStep = screenStep.MAIN);
      return state;
    },
    setReport: (state, action) => {
      state.selectedReport = action.payload;
      return state;
    },
    setOrg: (state, action) => {
      state.selectedOrg = action.payload;
      return state;
    },
    setFilterValue: (state, action) => {
      const {filterKey, filterVal} = action.payload;
      state.filterListValues.find((f) => f.id == filterKey).value = filterVal;
      return state;
    },
    returnToMain: (state, action) => {
      state.screenStep = screenStep.MAIN;
      return state;
    },
  },
  extraReducers: {
    [getCustomerReports.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        return {
          ...state,
          orgList: action.payload.Body.organizations,
          selectedOrg:
            action.payload.Body.organizations.length == 1 ? action.payload.Body.organizations[0].organizationId : state.selectedOrg,
          reportList: action.payload.Body.reports,
          error: null,
        };
      } else {
        return {
          ...state,
          error: {isError: true},
        };
      }
    },
    [getCustomerReports.rejected]: (state, action) => {
      return {
        ...state,
        error: {isError: true},
      };
    },
    [getBansForOrg.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        return {
          ...state,
          orgBanList: action.payload.Body,
        };
      } else {
        return {
          ...state,
          error: {isError: true},
        };
      }
    },
    [getBansForOrg.rejected]: (state, action) => {
      return {
        ...state,
        error: {isError: true},
      };
    },
    [sendReportToCustomer.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        if (action.payload.Body.isSuccess) {
          return {
            ...state,
            screenStep: screenStep.SUCCESS,
            error: null,
          };
        } else {
          return {
            ...state,
            screenStep: screenStep.FAILURE,
            error: {isError: true, errorDesc: action.payload.Body.codeError},
          };
        }
      } else {
        return {
          ...state,
          screenStep: screenStep.FAILURE,
          error: {isError: true, errorDesc: 'SERVER_FAIL'},
        };
      }
    },
    [sendReportToCustomer.rejected]: (state, action) => {
      return {
        ...state,
        screenStep: screenStep.FAILURE,
        error: {isError: true, errorDesc: 'SERVER_FAIL'},
      };
    },
  },
});

export const {setReport, setOrg, setFilterValue, returnToMain, resetState} = BusinessReportBlockSlice.actions;
export default BusinessReportBlockSlice.reducer;
